<template>
    <div class="row">
        <div class="col-12 mb-1">
            <b-alert show variant="secondary" class="p-1 mb-50">
                <small>
                    Fiyatı değiştirmek istediğiniz satırlara yeni fiyat yazınız; boş bırakılan
                    satırlara dokunulmaz. Fiyatı <b>değiştirmeden</b> yalnızca mazot baz tarihini
                    taşımak isterseniz fiyatı boş bırakıp o satırda <b>yeni pazarlık</b> seçip
                    baz tarih vermeniz yeterli.
                </small>
            </b-alert>

            <button class="btn btn-sm btn-flat-primary p-0" v-on:click="showHelp = !showHelp">
                <feather-icon icon="HelpCircleIcon" size="14" class="mr-25"></feather-icon>
                Nasıl çalışır?
                <feather-icon :icon="showHelp ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="12"></feather-icon>
            </button>
            <div v-if="showHelp" class="border rounded p-1 mt-50 bg-light">
                <small>
                    <b>Neden iki tür değişiklik var?</b><br>
                    Bir fiyatın değişmesinin iki sebebi olabilir ve ikisinin mazot hesabına etkisi
                    birbirinin tersidir. Yanlış seçim, ya zam kaybına ya çifte zamma yol açar.
                    <div class="table-responsive mt-50">
                        <table class="table table-sm table-bordered bg-white mb-0">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-nowrap">Düzeltme</th>
                                    <th class="text-nowrap">Yeni pazarlık</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="font-weight-bolder">Ne zaman</td>
                                    <td>Fiyat yanlış girilmişti</td>
                                    <td>Nakliyeciyle yeni fiyatta anlaşıldı</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Fiyat ne zaman geçerli</td>
                                    <td>Bugünden</td>
                                    <td>Seçtiğiniz baz tarihten</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Mazot baz'ı</td>
                                    <td>Korunur, birikmiş fark durur</td>
                                    <td>Seçtiğiniz güne taşınır, birikim sıfırlanır</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Geçmiş fiyat kaydı</td>
                                    <td class="text-success">Tamamen korunur</td>
                                    <td class="text-danger">Baz tarihten sonrakiler silinir</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Geçmiş sefer maliyeti</td>
                                    <td class="text-success">Değişmez</td>
                                    <td class="text-danger">Baz tarihten sonrası yeniden fiyatlanır</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bolder">Ara zam</td>
                                    <td>Üretilmez</td>
                                    <td>Baz tarih geçmişteyse üretilir</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr class="my-50">

                    <b>Düzeltme güvenli olandır.</b> Geçmişe hiç dokunmaz, muhasebeyle ayrışma
                    yaratmaz. Baz korunduğu için düzelttiğiniz fiyatın üstüne, mazot eşiği
                    aşıldığında gece servisinde zam gelebilir — birikim korunuyor demek budur.
                    <hr class="my-50">

                    <b>Yeni pazarlıkta baz tarih geçmişte ise</b><br>
                    Fiyat o günden itibaren yazılır, baz tarihten bugüne kadarki mazot hareketleri
                    ara zam olarak üretilir ve o pencerede kalan eski fiyat versiyonları silinir.
                    Kaydetmeden önce <b>Güncel Fiyatları Hesapla</b> ile sonucu görün; ara zamların
                    gün gün detayı için "N ara zam" yazısına tıklayın.
                    <hr class="my-50">

                    <b>Hata olursa</b><br>
                    Satırlardan biri bile hatalıysa <b>hiçbir fiyat güncellenmez</b>.
                    Yarım uygulanmış fiyat listesi oluşmaz.
                    <hr class="my-50">

                    <b>Gerekçe alanı</b><br>
                    Zorunlu değil ama doldurun: bu değişikliğin <u>neden</u> yapıldığının kaydı
                    şimdilik yalnızca orada tutuluyor.
                </small>
            </div>
        </div>

        <!-- Excel ile toplu doldurma. Şablon, sözleşme detayındaki "Rota Fiyatlar" çıktısından
             ayrı bir dosyadır: mevcut fiyatın yanında boş "Yeni Fiyat" ve "Değişiklik Türü"
             kolonlarını taşır. Yükleme hiçbir şey kaydetmez, yalnızca tabloyu doldurur. -->
        <div class="col-12 mb-1">
            <div class="border rounded p-1">
                <div class="d-flex flex-wrap align-items-center">
                    <b class="mr-1">Excel ile doldur</b>
                    <button class="btn btn-sm btn-flat-secondary mr-1" v-on:click="downloadTemplate" :disabled="templateDownloading">
                        <div v-if="templateDownloading" class="spinner-border spinner-border-sm mr-25"></div>
                        <feather-icon v-else icon="DownloadIcon" size="14" class="mr-25"></feather-icon>
                        Şablon İndir
                    </button>
                    <div class="flex-grow-1" style="min-width:220px">
                        <v-file-uploader :accept="['xlsx']" v-model="templateFile" valueParameter="File"></v-file-uploader>
                    </div>
                    <v-executer
                        class="ml-1"
                        variant="primary"
                        :action="uploadTemplate"
                        :loading="templateUploading"
                        :disabled="templateFile.File == null">
                        Şablon Yükle
                    </v-executer>
                </div>
                <small class="text-muted d-block mt-50">
                    Şablonu indirin, <b>Yeni Fiyat</b> kolonunu doldurun, gerekiyorsa
                    <b>Değişiklik Türü</b> olarak "Yeni Pazarlık" seçin ve dosyayı geri yükleyin.
                    Yükleme yalnızca aşağıdaki tabloyu doldurur; <b>fiyatlar kaydedilmez</b>,
                    kaydetmek için tabloyu kontrol edip "Fiyatları Güncelle" demeniz gerekir.
                    <b>Rota Kimliği</b> kolonunu silmeyin.
                    <br>
                    <b>Baz tarih şablonda yoktur</b>: mazot kaydı olan günlerden seçilmesi gerektiği
                    için yeni pazarlık satırlarında baz tarihi bu ekrandan verirsiniz.
                </small>

                <b-alert v-if="templateResult" show :variant="templateResult.SkippedCount ? 'warning' : 'success'" class="p-1 mb-0 mt-1">
                    <small>
                        <b>{{ templateResult.AppliedCount }}</b> satır tabloya yansıtıldı,
                        <b>{{ templateResult.SkippedCount }}</b> satır atlandı.
                        <span v-if="renegotiationRows.length" class="d-block mt-25">
                            <b>{{ renegotiationRows.length }}</b> satırda yeni pazarlık seçili;
                            kaydedebilmek için aşağıdaki tablodan <b>baz tarih</b> seçmelisiniz.
                        </span>
                        <template v-if="templateResult.Warnings && templateResult.Warnings.length">
                            <button class="btn btn-sm btn-flat-dark p-0 ml-50" v-on:click="showTemplateWarnings = !showTemplateWarnings">
                                Atlanan satırlar
                                <feather-icon :icon="showTemplateWarnings ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="12"></feather-icon>
                            </button>
                            <div v-if="showTemplateWarnings" class="table-responsive mt-50">
                                <table class="table table-sm table-bordered bg-white mb-0">
                                    <thead>
                                        <tr>
                                            <th class="text-nowrap">Rota</th>
                                            <th class="text-nowrap">Ürün</th>
                                            <th class="text-nowrap">Sebep</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(w,i) in templateResult.Warnings" :key="i">
                                            <td class="text-nowrap">{{ w.StartRegionName }} → {{ w.EndRegionName }}</td>
                                            <td class="text-nowrap">{{ w.StockCode }}</td>
                                            <td>{{ w.Message }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </small>
                </b-alert>
            </div>
        </div>

        <!-- Yeni pazarlıkta baz tarih geçmişteyse fiyat o günden itibaren yazılır ve aradaki
             mazot hareketleri geriye dönük uygulanır; kullanıcı kaydetmeden önce sonucu görmeli. -->
        <div class="col-12 mb-1" v-if="renegotiationRows.length">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <small class="text-muted">
                    {{ renegotiationRows.length }} satırda yeni pazarlık seçili.
                    Baz tarihten bugüne oluşacak ara zamları görmek için hesaplayınız.
                </small>
                <v-executer
                    variant="primary"
                    :action="simulate"
                    :loading="simulating"
                    :disabled="!canSimulate">
                    Güncel Fiyatları Hesapla
                </v-executer>
            </div>
            <b-alert v-if="simulation" show variant="info" class="p-1 mb-0 mt-50">
                <b>{{ simulation.TotalStepCount }}</b> geriye dönük ara zam ·
                kaydedildiğinde toplam <b>{{ simulation.TotalRowCount }}</b> fiyat satırı yazılacak ·
                {{ simulation.TotalStartPriceStr }} ₺ → <b>{{ simulation.TotalFinalPriceStr }} ₺</b>
            </b-alert>
        </div>

        <div class="col-12">
            <div class="table-responsive">
                <table class="table table-sm table-bordered align-middle mb-0">
                    <thead>
                        <tr>
                            <th class="text-nowrap">Rota</th>
                            <th class="text-nowrap">Ürün</th>
                            <th class="text-nowrap text-right">Mevcut Fiyat</th>
                            <th class="text-nowrap" style="min-width:140px">Yeni Fiyat</th>
                            <th class="text-nowrap" style="min-width:150px">Değişiklik Türü</th>
                            <th class="text-nowrap" style="min-width:220px">Yeni Baz Tarih</th>
                            <th class="text-nowrap text-right" style="min-width:150px">Güncel Fiyat</th>
                            <th class="text-nowrap" style="min-width:180px">Gerekçe</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="row in rows">
                        <tr :key="row.Id">
                            <td class="text-nowrap">
                                {{ row.StartRegionName }} → {{ row.EndRegionName }}
                                <small class="d-block text-muted">{{ row.VehicleTypeName }} · {{ row.StatusStr }}</small>
                            </td>
                            <td class="text-nowrap">{{ row.StockName }}</td>
                            <td class="text-nowrap text-right">{{ row.PriceStr }} ₺</td>
                            <td>
                                <v-currency-input
                                    input-class="text-right"
                                    :value="row.NewPrice"
                                    v-on:update-value="amount => setNewPrice(row, amount)"></v-currency-input>
                            </td>
                            <td>
                                <!-- Her zaman açık: fiyat girilmeden de "yeni pazarlık" seçilip
                                     yalnızca baz taşınabilmeli. -->
                                <select class="form-control form-control-sm" v-model="row.ChangeKind" v-on:change="onChangeKind(row)">
                                    <option value="correction">Düzeltme</option>
                                    <option value="renegotiation">Yeni pazarlık</option>
                                </select>
                            </td>
                            <td>
                                <!-- append-to-body: açılır liste tablonun ve modal gövdesinin
                                     overflow kırpmasından kurtulsun diye body'ye taşınıyor. -->
                                <v-select-list
                                    v-if="row.ChangeKind === 'renegotiation'"
                                    append-to-body
                                    :calculate-position="positionDropdown"
                                    :value="fuelBaseOf(row)"
                                    v-on:input="value => setFuelBase(row, value)"
                                    placeholder="Baz tarih seçiniz"
                                    label="Label"
                                    :loading="fuelPricesLoading"
                                    :options="fuelPrices"/>
                                <small v-else class="text-muted">baz korunur</small>
                            </td>
                            <td class="text-nowrap text-right">
                                <template v-if="row.ChangeKind !== 'renegotiation' || !isChanged(row)">
                                    <small class="text-muted">-</small>
                                </template>
                                <template v-else-if="isRebaseOnly(row) && !simulationByRow[row.Id]">
                                    <small class="text-muted">fiyat korunur</small>
                                </template>
                                <template v-else-if="simulationByRow[row.Id]">
                                    <span v-if="simulationByRow[row.Id].ErrorMessage" class="text-danger">
                                        <small>{{ simulationByRow[row.Id].ErrorMessage }}</small>
                                    </span>
                                    <template v-else>
                                        <b>{{ simulationByRow[row.Id].Escalation.FinalPriceStr }} ₺</b>
                                        <button
                                            v-if="simulationByRow[row.Id].Escalation.Steps.length"
                                            class="btn btn-link btn-sm p-0 d-block ml-auto"
                                            v-on:click="toggleSteps(row.Id)">
                                            <small>
                                                {{ simulationByRow[row.Id].Escalation.Steps.length }} ara zam
                                                ({{ simulationByRow[row.Id].Escalation.TotalChangeRateStr }})
                                                <feather-icon
                                                    :icon="isExpanded(row.Id) ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                                                    size="12"></feather-icon>
                                            </small>
                                        </button>
                                        <small v-else class="d-block text-muted">ara zam yok</small>
                                    </template>
                                </template>
                                <small v-else class="text-muted">hesaplanmadı</small>
                            </td>
                            <td>
                                <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    :disabled="!isChanged(row)"
                                    v-model="row.ChangeNote"
                                    placeholder="Opsiyonel" />
                            </td>
                        </tr>
                        <!-- Ara zam detayı: baz tarihten bugüne hangi günde hangi mazot
                             değişimiyle hangi zammın oluştuğu. -->
                        <tr v-if="isExpanded(row.Id) && simulationByRow[row.Id]" :key="row.Id + '-steps'">
                            <td colspan="100" class="bg-light p-1">
                                <small class="text-muted d-block mb-50">
                                    {{ row.StartRegionName }} → {{ row.EndRegionName }} ·
                                    baz {{ simulationByRow[row.Id].Escalation.BaseDateStr }}
                                    ({{ simulationByRow[row.Id].Escalation.BaseFuelPriceStr }} ₺) ·
                                    girilen fiyat {{ simulationByRow[row.Id].Escalation.StartPriceStr }} ₺
                                </small>
                                <table class="table table-sm table-bordered bg-white mb-0">
                                    <thead>
                                        <tr>
                                            <th class="text-nowrap">Tarih</th>
                                            <th class="text-nowrap text-right">Mazot</th>
                                            <th class="text-nowrap text-right">Değişim</th>
                                            <th class="text-nowrap text-right">Eski Fiyat</th>
                                            <th class="text-nowrap text-right">Yeni Fiyat</th>
                                            <th class="text-nowrap text-right">Fark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s,si) in simulationByRow[row.Id].Escalation.Steps" :key="si">
                                            <td class="text-nowrap">{{ s.DateStr }}</td>
                                            <td class="text-nowrap text-right">{{ s.PreviousFuelPriceStr }} → {{ s.FuelPriceStr }}</td>
                                            <td class="text-nowrap text-right">{{ s.FuelChangeRateStr }}</td>
                                            <td class="text-nowrap text-right">{{ s.OldPriceStr }}</td>
                                            <td class="text-nowrap text-right font-weight-bolder">{{ s.NewPriceStr }}</td>
                                            <td class="text-nowrap text-right">{{ s.PriceDeltaStr }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </template>
                        <tr v-if="rows.length === 0">
                            <td colspan="100" class="text-center">Güncellenecek rota bulunmuyor.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-12 mt-1" v-if="validationMessage">
            <b-alert show variant="warning" class="p-1 mb-0">
                <small>{{ validationMessage }}</small>
            </b-alert>
        </div>

        <div class="col-12 mt-1" v-if="saveErrors.length">
            <b-alert show variant="danger" class="p-1 mb-0">
                <b>Hiçbir fiyat güncellenmedi.</b>
                <ul class="mb-0 mt-50 pl-2">
                    <li v-for="(e,i) in saveErrors" :key="i"><small>{{ e.Message }}</small></li>
                </ul>
            </b-alert>
        </div>
    </div>
</template>

<script>
import { AgreementApi } from '@/api/agreement'
import { FuelPriceApi } from '@/api/fuel-price'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import VExecuter from '@/components/VExecuter.vue'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import Additional from '@/utilities/additional'
import { BAlert } from 'bootstrap-vue'
import moment from 'moment'

export default {
    components:{
        VCurrencyInput,
        VExecuter,
        VFileUploader,
        BAlert
    },
    props:{
        // Sözleşme detayındaki güncel rota satırları.
        routePrices:Array,
        agreementId:String
    },
    data(){
        return {
            rows:[],
            fuelPrices:[],
            fuelPricesLoading:false,
            templateFile:{ File:null },
            templateDownloading:false,
            templateUploading:false,
            templateResult:null,
            showTemplateWarnings:false,
            saveErrors:[],
            simulation:null,
            simulating:false,
            expandedRows:[],
            showHelp:false
        }
    },
    mounted(){
        this.getFuelPrices()
        this.buildRows()
    },
    watch:{
        routePrices(){
            this.buildRows()
        },
        canSave:{
            immediate:true,
            handler(value){
                this.$emit('ready',value)
            }
        }
    },
    methods:{
        buildRows(){
            this.saveErrors = []
            this.simulation = null
            this.expandedRows = []
            this.templateResult = null
            this.showTemplateWarnings = false
            this.rows = (this.routePrices || []).map(r => ({
                Id: r.Id,
                StartRegionName: r.StartRegionName,
                EndRegionName: r.EndRegionName,
                VehicleTypeName: r.VehicleTypeName,
                StockCode: r.StockCode,
                StockName: r.StockName,
                StatusStr: r.StatusStr,
                PriceStr: r.PriceStr,
                Price: r.Price,
                NewPrice: null,
                ChangeKind: 'correction',
                FuelBaseDate: null,
                ChangeNote: null
            }))
        },
        downloadTemplate(){
            this.templateDownloading = true
            AgreementApi.DownloadRoutePriceTemplate(this.agreementId).then(res=>{
                Additional.DownloadFile(res.data,'Fiyat Guncelleme Sablonu.xlsx')
                this.templateDownloading = false
            }).catch(err=>{
                this.$result(null,err)
                this.templateDownloading = false
            })
        },
        // Şablonu okur ve dönen satırları tabloya yansıtır. Kaydetme yapılmaz; kullanıcı
        // sonucu tabloda görüp "Fiyatları Güncelle" ile kendi onaylar.
        async uploadTemplate(){
            this.templateUploading = true
            this.templateResult = null
            this.showTemplateWarnings = false

            const data = await Additional.ToFormData({
                AgreementId: this.agreementId,
                File: this.templateFile.File
            })

            AgreementApi.ReadRoutePriceTemplate(data).then(res=>{
                const payload = res.data.Data
                if(payload)
                    this.templateResult = payload

                if(res.data.Success && payload)
                    this.applyTemplateRows(payload.Rows || [])

                this.$result(res)
                this.templateUploading = false
            }).catch(err=>{
                this.$result(null,err)
                this.templateUploading = false
            })
        },
        applyTemplateRows(templateRows){
            this.simulation = null
            this.expandedRows = []

            templateRows.forEach(templateRow => {
                const row = this.rows.find(r => r.Id === templateRow.RouteId)
                if(!row)
                    return

                row.ChangeKind = templateRow.ChangeKind === 'renegotiation' ? 'renegotiation' : 'correction'
                row.FuelBaseDate = templateRow.FuelBaseDate ? moment(templateRow.FuelBaseDate).format('YYYY-MM-DD') : null
                row.ChangeNote = templateRow.ChangeNote || null
                // setNewPrice üzerinden geçilir ki yarım kalan satırı temizleyen mevcut kural
                // burada da işlesin.
                this.setNewPrice(row, templateRow.NewPrice)
            })
        },
        getFuelPrices(){
            this.fuelPricesLoading = true
            FuelPriceApi.List().then(res=>{
                this.fuelPrices = res.data.Data || []
                this.fuelPricesLoading = false
            }).catch(err=>{
                console.error(err)
                this.fuelPricesLoading = false
            })
        },
        toggleSteps(id){
            const index = this.expandedRows.indexOf(id)
            if(index >= 0)
                this.expandedRows.splice(index,1)
            else
                this.expandedRows.push(id)
        },
        isExpanded(id){
            return this.expandedRows.indexOf(id) >= 0
        },
        // Satır iki sebeple işleme girebilir: fiyat değişmiştir, ya da fiyat aynı kalıp yalnızca
        // mazot baz'ı taşınmaktadır (birikmiş zamlardan feragat senaryosu). İkincisini de
        // kapsamazsak "fiyat aynı kalsın ama baz bugüne gelsin" hiç yapılamaz.
        isChanged(row){
            return this.isPriceChanged(row) || this.isRebaseOnly(row)
        },
        isPriceChanged(row){
            return row.NewPrice != null && row.NewPrice > 0 && row.NewPrice !== row.Price
        },
        isRebaseOnly(row){
            return row.ChangeKind === 'renegotiation' && !!row.FuelBaseDate && !this.isPriceChanged(row)
        },
        // Fiyat girilmediyse mevcut fiyat korunur; sunucuya her zaman geçerli bir fiyat gider.
        effectivePrice(row){
            return this.isPriceChanged(row) ? row.NewPrice : row.Price
        },
        setNewPrice(row, amount){
            row.NewPrice = amount
            // Fiyat değiştiği anda önceki hesap geçersizdir.
            this.simulation = null
            this.expandedRows = []
            // Satır tamamen işlem dışı kaldıysa seçimleri de sıfırla; yarım kalmış bir satır
            // kaydedilmeye çalışılmasın.
            if(!this.isChanged(row)){
                row.ChangeKind = 'correction'
                row.FuelBaseDate = null
                row.ChangeNote = null
            }
        },
        onChangeKind(row){
            this.simulation = null
            this.expandedRows = []
            if(row.ChangeKind === 'correction')
                row.FuelBaseDate = null
        },
        // append-to-body kullanıldığında konumlandırma bize kalıyor. Liste tetikleyicinin
        // hemen altına yerleşir; ekranın altına taşacaksa üstte açılır. z-index modal'ın
        // üstünde olmalı, aksi halde body'ye taşınan liste modal'ın arkasında kalır.
        positionDropdown(dropdownList, component, { width }){
            const rect = component.$refs.toggle.getBoundingClientRect()
            const spaceBelow = window.innerHeight - rect.bottom
            const openUp = spaceBelow < 240 && rect.top > spaceBelow

            dropdownList.style.width = width
            dropdownList.style.position = 'absolute'
            dropdownList.style.zIndex = 1080
            dropdownList.style.maxHeight = '240px'
            dropdownList.style.left = (rect.left + window.scrollX) + 'px'
            dropdownList.style.top = openUp
                ? (rect.top + window.scrollY - Math.min(240, dropdownList.offsetHeight || 240)) + 'px'
                : (rect.bottom + window.scrollY) + 'px'
        },
        fuelBaseOf(row){
            if(!row.FuelBaseDate) return null
            return this.fuelPrices.find(f => moment(f.Date).isSame(moment(row.FuelBaseDate),'day')) || null
        },
        setFuelBase(row, value){
            row.FuelBaseDate = value == null ? null : moment(value.Date).format('YYYY-MM-DD')
            this.simulation = null
            this.expandedRows = []
        },
        simulate(){
            if(!this.canSimulate)
                return

            this.simulating = true
            this.simulation = null
            this.expandedRows = []
            AgreementApi.SimulateRoutes({
                AgreementId: this.agreementId,
                Routes: this.renegotiationRows.map(r => ({
                    RowKey: r.Id,
                    StartRegionName: r.StartRegionName,
                    EndRegionName: r.EndRegionName,
                    StockName: r.StockName,
                    Price: this.effectivePrice(r),
                    FuelBaseDate: r.FuelBaseDate
                }))
            }).then(res=>{
                if(res.data.Success)
                    this.simulation = res.data.Data
                else
                    this.$result(res)
                this.simulating = false
            }).catch(err=>{
                this.$result(null,err)
                this.simulating = false
            })
        },
        // Üst ekran tarafından çağrılır.
        save(){
            this.saveErrors = []
            return AgreementApi.UpdateRoutePrices({
                Items: this.changedRows.map(r => ({
                    Id: r.Id,
                    Price: this.effectivePrice(r),
                    // Düzeltmede baz tarih gönderilmez: sunucu mevcut baz'ı korur.
                    FuelBaseDate: r.ChangeKind === 'renegotiation' ? r.FuelBaseDate : null,
                    ChangeNote: r.ChangeNote || null
                }))
            }).then(res=>{
                if(!res.data.Success && res.data.Data)
                    this.saveErrors = res.data.Data.Errors || []
                return res
            })
        }
    },
    computed:{
        changedRows(){
            return this.rows.filter(r => this.isChanged(r))
        },
        renegotiationRows(){
            return this.changedRows.filter(r => r.ChangeKind === 'renegotiation')
        },
        canSimulate(){
            return this.renegotiationRows.length > 0
                && this.renegotiationRows.every(r => r.FuelBaseDate)
        },
        simulationByRow(){
            const map = {}
            if(this.simulation && this.simulation.Routes){
                this.simulation.Routes.forEach(r => { map[r.RowKey] = r })
            }
            return map
        },
        validationMessage(){
            if(this.changedRows.length === 0)
                return 'Değiştirilen fiyat yok.'

            const missingBase = this.changedRows.some(r => r.ChangeKind === 'renegotiation' && !r.FuelBaseDate)
            if(missingBase)
                return 'Yeni pazarlık seçilen satırlarda baz tarih seçilmelidir.'

            return null
        },
        canSave(){
            return this.validationMessage == null
        }
    }
}
</script>
